export default __webpack_public_path__ + "fonts/poppins-latin-800-normal.ca6a92cea2062ebec667.woff2";